var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 69 38",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.00285C1 4.23985 3.23985 2 6.00285 2C8.76585 2 11.0057 4.23985 11.0057 7.00285C11.0057 9.76585 8.76585 12.0057 6.00285 12.0057C3.23985 12.0057 1 9.76585 1 7.00285ZM11.006 29.9706C11.006 32.7336 8.7661 34.9735 6.0031 34.9735C3.2401 34.9735 1.00025 32.7336 1.00025 29.9706V18.646C1.00025 15.883 3.2401 13.6431 6.0031 13.6431C8.7661 13.6431 11.006 15.883 11.006 18.646V29.9706ZM46.0605 34.3022C43.6676 35.6837 40.608 34.8639 39.2265 32.471L31.5293 19.1392L23.9741 32.4717C22.5963 34.9031 19.4736 35.7224 17.0648 34.3055C14.7104 32.9206 13.8825 29.8918 15.2291 27.5153L27.1233 6.52593C28.5011 4.09455 31.6238 3.27524 34.0326 4.69216C34.8897 5.19631 35.5445 5.91831 35.9657 6.74739L38.0402 10.405L47.8916 27.4682C49.2731 29.861 48.4533 32.9207 46.0605 34.3022ZM57.6544 32.3693C59.0322 34.8007 62.1549 35.62 64.5637 34.2031C66.918 32.8182 67.746 29.7894 66.3993 27.4129L54.5052 6.42353C53.1274 3.99215 50.0046 3.17285 47.5958 4.58977C46.7395 5.09346 46.0852 5.81462 45.6639 6.64276L41.9572 13.178C43.3898 11.6567 45.8695 11.8817 47.0048 13.6361L47.2778 14.058L57.6544 32.3693Z",
    fill: "url(#paint0_linear_118_5600)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_5600",
    x1: 52.993,
    y1: 27.5055,
    x2: 1.00004,
    y2: 20.6384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DB2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.525f094bae95a84bd35a4d30336aa89c.svg";
export { ForwardRef as ReactComponent };